import React from 'react';
import Menu from '../containers/MenuP/Menu-Preview';
import Footer from '../containers/Footer/Footer';

  
const MenuPage = () => {
  return (
    <div>
      <Menu />
      <Footer />
    </div>
  );
};
  
export default MenuPage;